export var SHOW_TOAST = 'SHOW_TOAST';
export var showToastAction = function showToastAction() {
  return {
    type: SHOW_TOAST
  };
};